import React from 'react'

const PriceModuleSkeleton = ({rows}) => {
    return (
        <>
            <style>
                {
                    `
                        .skeleton {
                            animation: pulse 1.5s infinite ease-in-out !important;
                            background: #d5d6d8ff !important;
                            border-radius: 3px !important;
                        }
                        @keyframes pulse {
                            0%, 100% {
                                opacity: 1;
                            }
                            50% {
                                opacity: 0.4;
                            }
                        }
                    `
                }
            </style>
            {[...Array(rows)].map((_, index) => (
                <tr key={index}>
                    <td>
                        <div className='skeleton rounded' style={{height:'20px', width:'120px'}}></div>
                    </td>
                    <td>
                        <div className='skeleton rounded' style={{height:'20px', width:'150px'}}></div>
                    </td>
                    <td>
                        <div className='skeleton rounded' style={{height:'20px', width:'150px'}}></div>
                    </td>
                    <td className='float-end d-flex'>
                        <div className='skeleton rounded me-2' style={{height:'30px', width:'30px'}}></div>
                        <div className='skeleton rounded' style={{height:'30px', width:'30px'}}></div>
                    </td>
                </tr>
            ))}
            
        </>
    )
}

export default PriceModuleSkeleton